"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTextAreaAppearance = exports.CustomTextInputAppearance = void 0;
var CustomTextInputAppearance;
(function (CustomTextInputAppearance) {
    CustomTextInputAppearance[CustomTextInputAppearance["Default"] = 0] = "Default";
    CustomTextInputAppearance[CustomTextInputAppearance["Disabled"] = 1] = "Disabled";
    CustomTextInputAppearance[CustomTextInputAppearance["Error"] = 2] = "Error";
    CustomTextInputAppearance[CustomTextInputAppearance["Success"] = 3] = "Success";
    CustomTextInputAppearance[CustomTextInputAppearance["ReadOnly"] = 4] = "ReadOnly";
    CustomTextInputAppearance[CustomTextInputAppearance["Search"] = 5] = "Search";
})(CustomTextInputAppearance || (exports.CustomTextInputAppearance = CustomTextInputAppearance = {}));
// to start from 5 is necessary for the differentiation of enum values between CustomTextInputAppearance and CustomTextAreaAppearance for later used switch cases
var CustomTextAreaAppearance;
(function (CustomTextAreaAppearance) {
    CustomTextAreaAppearance[CustomTextAreaAppearance["Default"] = 5] = "Default";
    CustomTextAreaAppearance[CustomTextAreaAppearance["Disabled"] = 6] = "Disabled";
    CustomTextAreaAppearance[CustomTextAreaAppearance["Error"] = 7] = "Error";
    CustomTextAreaAppearance[CustomTextAreaAppearance["ReadOnly"] = 8] = "ReadOnly";
    CustomTextAreaAppearance[CustomTextAreaAppearance["Search"] = 9] = "Search";
})(CustomTextAreaAppearance || (exports.CustomTextAreaAppearance = CustomTextAreaAppearance = {}));
